


































































































import { Component, Vue, Prop } from 'vue-property-decorator';
// import EnquiryFormModal from '@/components/operate/EnquiryFormModal.vue';
import { getSchoolId, getSchoolInfo } from '@/utils/utils';
import config from '@/school.config';
@Component({
  components: {
    // EnquiryFormModal,
  },
})
export default class MainInfo extends Vue {
  @Prop({ default: () => {} }) public data!: any;
  public isEdit: boolean = false;
  public config = config;

  public get locale(): string {
    return this.$i18n.locale;
  }
 
  public get fields() {
    return this.data.formFields.filter((item: any) => item.selectedFlag).map((item: any) => item.property);
  }
  public get school() {
    return getSchoolInfo().shortName;
  }
}
